import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <footer className="footer">
      Copyright &#169; 2024 TheCodeSphere. All Right Received. 
    </footer>
  )
}

export default Footer
